import React from "react";
import { Translation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { Row, Col, FormGroup, Input, Button, Label, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody } from "reactstrap";
import { Form, Field } from "react-final-form";
import ServicesService from "../services.service";
import AuthService from "../../../Authentication/auth.service";

import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../../../components/Loaders/DnaLoader";
import "../../../../assets/custom css/loadoverlay.scss";

import Alerts from "../../../../components/Alerts/alerts";


class EditServicePrice extends React.Component {
  componentDidMount() {
    this.getPackaging();
    // this.getPackagingSizes();
  }
  constructor(props) {
    super(props);
    console.log("Received Prop:-", props);
    this.state = {
      modal: false,
      backdrop: true,
      loading: false,
      loginNavigate: false,
      packagings: [],
      // packagingSizes: []
    };
    this.toggle = this.toggle.bind(this);
    this.validateFtn = this.validateFtn.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.getPackaging = this.getPackaging.bind(this);
    // this.getPackagingSizes = this.getPackagingSizes.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  getPackaging() {
    ServicesService.getPackaging().then((response) => {
      console.log("Get Packagings response:-", response);
      this.setState({
        packagings: response.data.data,
      });
    },
      (error) => {
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert("Server Error, Please try again later.")
        }
      })
  }

  // getPackagingSizes() {
  //   ServicesService.getPackagingSizes().then((response) => {
  //     console.log("Get PackagingSizes response:-", response)
  //     this.setState({
  //       packagingSizes: response.data.data,
  //     });
  //   },
  //     (error) => {
  //       const errContent =
  //         (error.response && error.response.data) || error.message || error.toString();
  //       console.log("Net:-", errContent)
  //       if (errContent) {
  //         Alerts.swalErrorAlert(errContent)
  //       }
  //       else {
  //         Alerts.swalErrorAlert("Server Error, Please try again later.")
  //       }
  //     })
  // }

  validateFtn = values => {
    const errors = {};
    if (!values.packaging_id) {
      errors.packaging_id = "Packaging Name Required.";
    }
    // if (!values.packaging_size_id) {
    //   errors.packaging_size_id = "Packaging Size Required.";
    // }
    if (!values.price) {
      errors.price = "Price Required.";
    }
    return errors;
  };

  onSubmit = values => {
    console.log(values);
    var payloadData = {
      functionName: "GUpdateServiceMasterPricingetDrivers",
      postData: {
        packaging_id: values.packaging_id,
        // packaging_size_id: values.packaging_size_id,
        price: values.price,
        _id: this.props.data._id,
        service_id: this.props.data.service_id
      }
    }
    this.setState({
      loading: !this.state.loading,
    });
    ServicesService.updateServiceDetail(payloadData).then((response) => {
      console.log("API Response:-", response);
      this.setState({
        loading: !this.state.loading,
      });
      if (response.data.status) {
        // this.toggle();
        // window,location.reload();
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message).then(res => {
            console.log("Resp:-", res)
            this.toggle();
            window.location.reload();
          })
        }
        else {
          Alerts.swalSuccessAlert("Master Packaging Price Updated successfully.").then(res => {
            console.log("Resp:-", res)
            this.toggle();
            window.location.reload();
          })
        }
      }
      else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            this.setState({ loginNavigate: true });
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message).then(res => {
              console.log("Resp:-", res)
              this.toggle();
              window.location.reload();
            })
          }
        }
        else {
          Alerts.swalErrorAlert("Error: Can't update Master Package Pricing at the moment. Please try again later.")
        }
      }
    },
      (error) => {
        this.setState({
          loading: !this.state.loading,
        });
        const resMessage = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        Alerts.swalErrorAlert("Network Operation failed.")
      });
  }


  render() {
    // this.getPackaging()
    // this.getPackagingSizes()
    {this.state.loginNavigate &&
      <Navigate to={'/login'} />
    }
    return (
      <Translation>
        {(t) => (
          <span className="d-inline-block mb-2">
            <i onClick={this.toggle} className="pe-7s-pen btn-icon-wrapper text-info"> </i>
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop={true}>
              <LoadingOverlay tag="div" active={this.state.loading}
                styles={{ overlay: (base) => ({ ...base }) }}
                spinner={<DNALoader />}>
                <ModalHeader >Edit Service Price</ModalHeader>
                <ModalBody>
                  <Card className="main-card mb-3">
                    <CardBody>
                      <Row>
                        <Col md="12" className="pt-3">
                          <Form onSubmit={this.onSubmit}
                            initialValues={this.props.data}
                            validate={this.validateFtn}
                            render={({ handleSubmit, values, submitting, validating, valid }) => (
                              <form onSubmit={handleSubmit}>
                                <Row>
                                  <Col md="6">
                                    <FormGroup>
                                      <Field name="packaging_id">
                                        {({ input, meta }) => (
                                          <div>
                                            <Input {...input} type="select" className="packclass"
                                              invalid={meta.error && meta.touched}
                                            >
                                              <option disabled={false} value="">Packaging</option>
                                              {this.state.packagings &&
                                                this.state.packagings.map((pack, inde) => (
                                                  <option key={inde} value={pack._id}>{pack.name}</option>
                                                ))
                                              }
                                            </Input>
                                            {meta.error && meta.touched &&
                                              <span className="text-danger">{meta.error}</span>}
                                          </div>
                                        )}
                                      </Field>
                                    </FormGroup>
                                  </Col>
                                  {/* <Col md="4">
                                    <FormGroup>
                                      <Field name="packaging_size_id">
                                        {({ input, meta }) => (
                                          <div>
                                            <Input {...input} type="select" className="sizeclass"
                                              invalid={meta.error && meta.touched}
                                            >
                                              <option disabled={false} value="">Size</option>
                                              {this.state.packagingSizes &&
                                                this.state.packagingSizes.map((size, ind) => (
                                                  <option key={ind} value={size._id}>{size.name}</option>
                                                ))
                                              }
                                            </Input>
                                            {meta.error && meta.touched &&
                                              <span className="text-danger">{meta.error}</span>}
                                          </div>
                                        )}
                                      </Field>
                                    </FormGroup>
                                  </Col > */}
                                  <Col md="6" >
                                    <FormGroup>
                                      <Field name="price" >
                                        {({ input, meta }) => (
                                          <div>
                                            <Input {...input} type="text" placeholder="Price" className="priceclass"
                                              invalid={meta.error && meta.touched}
                                            />
                                            {meta.error && meta.touched &&
                                              <span className="text-danger">{meta.error}</span>}
                                          </div>
                                        )}
                                      </Field>
                                    </FormGroup>
                                  </Col>
                                  <div className="text-center">
                                    <FormGroup>
                                      <div className="text-center">
                                        <button type="submit" className="btn btn-secondary btn-lg btn-hover-shine me-3">
                                          Update </button>
                                        <button type="button" className="btn btn-outline-success btn-lg btn-hover-shine me-3" onClick={this.toggle}>
                                          Cancel
                                        </button>
                                      </div>
                                    </FormGroup>
                                  </div>
                                </Row>
                              </form>
                            )}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </ModalBody>
              </LoadingOverlay>
            </Modal>
          </span>
        )}
      </Translation>
    );
  };


};

export default EditServicePrice;